<template>
  <div id="user-rights">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
                ref="formselect"
              :model="formselect"
              label-width="100px"
              class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="8" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.keyword')">
                <el-input size="small" v-model="formselect.userName" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
             <!-- <el-col :md="16" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.Datefrom')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col> -->
             <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="$t('title.logType')">
                  <el-select
                    v-model="formselect.operateType"
                    size="small"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in lotTypeList"
                      :value="item.value"
                      :label="$t('opeateType.'+item.value)"
                      :key="'inx2' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="12">
                <el-form-item :label="'账号类型'">
                  <el-select
                    v-model="formselect.customerType"
                    size="small"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option value="后台" :label="$t('userType.backStage')"></el-option>
                    <el-option value="客户" :label="$t('userType.cutomer')"></el-option>
                    <el-option value="经销商" :label="$t('userType.agency')"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            
           <el-col :md="8" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.operateUser')">
                <el-input size="small" v-model="formselect.operator" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="6" :xs="24" :sm="12" style="margin-top: 6px">
              <el-button @click="getData" type="primary" size="small">{{
                $t("button.query")
              }}</el-button>
              <el-button @click="reset" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <div class="tableDiv">
          <el-table :data="tableData" stripe v-loading="loading" :empty-text="$t('desc.noData')">
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
               width="60"
            ></el-table-column>
            <el-table-column
              prop="operateType"
              :label="$t('title.logType')"
              min-width="10%"
            >
            <template slot-scope="scope">
                {{$t("opeateType."+scope.row.operateType)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="userName"
              :label="$t('title.account')"
              min-width="10%"
            ></el-table-column>
            <el-table-column
              prop="customerType"
              :label="$t('title.accountType')"
              min-width="10%"
            >
            <template slot-scope="scope">
                {{$t(customerType[scope.row.customerType?scope.row.customerType:"后台管理"])}}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('title.creatTime')"
              min-width="20%"
            >
              <template slot-scope="scope">
                {{scope.row.creationTime | dateFormat}}
              </template>
            </el-table-column>
             <el-table-column
              prop="operator"
              :label="$t('desc.operateUser')"
              min-width="10%"
            ></el-table-column>
          </el-table>
          <el-pagination
            background
            :page-size="pagination.pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="prev, pager, next,sizes"
            :total="pagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetAllOperationLogs, getPasswordLogs } from "../../api/api";

export default {
  name: "log",
  data() {
    return {
      loading: false,
      times: ["", ""],
      timeStartDefaultShow:"",
      timeEndDefaultShow:"",
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      formselect: {
        keywords: "",
        startTime: "",
        endTime: "",
        logType: "",
        userName:""
      },
      lotTypeList:[
        {lable: "创建", value:"create"},
        {lable: "修改", value:"edit"},
        {lable: "管理员重置", value:"reset"},
        {lable: "用户重置", value:"forget"},
      ],
      customerType:{
        "后台管理":"userType.backStage",
        "客户":"userType.cutomer",
        "经销商":"userType.agency",
      }
    };
  },
  created(){
    this.timeStartDefaultShow = new Date();
    //this.timeStartDefaultShow.setMonth(new Date().getMonth() - 1);
    this.timeStartDefaultShow.setDate(new Date().getDay() - 7);
    this.timeEndDefaultShow = new Date();
    this.times = [this.timeStartDefaultShow, this.timeEndDefaultShow];

  },
  mounted() {
    this.getData();
  },
  methods: {
    reset() {
      this.times = ["", ""];
      this.formselect = { keywords: "", startTime: "", endTime: "", logType: "" ,userName:""};
      this.getData();
    },
    getData() {
      var data = {
          skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
          maxResultCount:this.pagination.pageSize
        },
        that = this;
      data = { ...data, ...this.formselect };
      getPasswordLogs(data).then((res) => {
        if (res.success) {
          that.tableData = res.result.items;
          that.pagination.totalPage = res.result.totalCount;
        }
        that.loading = false;
      });
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
       this.getData();
    },
  },

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style scoped>
</style>
